"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceOf = exports.isTrue = exports.isFalse = void 0;
exports.isNil = isNil;
exports.isNotNil = isNotNil;
exports.isArray = isArray;
exports.isEqualById = isEqualById;
exports.isDeepEqual = isDeepEqual;
exports.isEqual = isEqual;
exports.isJsDate = isJsDate;
exports.getEmptyFields = getEmptyFields;
exports.isEmpty = isEmpty;
exports.isNotEmpty = isNotEmpty;
exports.isArrayEmpty = isArrayEmpty;
exports.isArrayNotEmpty = isArrayNotEmpty;
exports.throwIfNil = throwIfNil;
const ramda_1 = require("ramda");
const lodash_1 = require("lodash");
/**
 * Checks if the input is null or undefined.
 * @param value
 * @returns
 */
function isNil(value) {
    return (0, ramda_1.isNil)(value);
}
function isNotNil(value) {
    return !isNil(value);
}
function isArray(unk) {
    return Array.isArray(unk);
}
/**
 * @note Returns true if both objects are undefined
 * @param a
 * @param b
 * @returns
 */
function isEqualById(a, b) {
    return a?.id === b?.id;
}
function isDeepEqual(a, b) {
    return (0, lodash_1.isEqual)(a, b);
}
/**
 * Performs deep equality check
 * Statically typed unlike isDeepEqual
 * If you need to perform on objects of different types, use: isEqual<any>
 */
function isEqual(a, b) {
    return (0, lodash_1.isEqual)(a, b);
}
/**
 * Returns whether input is a Js date object
 */
function isJsDate(value) {
    return value instanceof Date;
}
/**
 * Gets an array of empty fields. No particular order
 * Empty means null, undefined, empty array, or empty object
 * @param obj
 */
function getEmptyFields(obj) {
    const fields = Object.keys(obj);
    const emptyFields = fields.filter(field => isEmpty(obj[field]));
    return emptyFields;
}
/**
 * Empty means null, undefined, empty array, or empty object
 * @param obj
 */
function isEmpty(value) {
    return (isNil(value) ||
        (typeof value === 'object' && Object.keys(value).length === 0 && !isJsDate(value)) ||
        (typeof value === 'string' && value.trim().length === 0));
}
function isNotEmpty(value) {
    return !isEmpty(value);
}
function isArrayEmpty(array) {
    return !array.length;
}
function isArrayNotEmpty(array) {
    return !isArrayEmpty(array);
}
/**
 * Throws an error if the value provided is nil
 * Since exceptions should be "exceptional", use this ONLY when we do not expect the result to be nil and need to handle it immediately
 * https://dev.to/jpswade/exceptions-are-meant-to-be-exceptional-4e3l
 *
 * @param value a value we do NOT expect to be nil, but want to handle in the event that it is
 * @param error if provided, will throw this type of error instead of the default error
 * @returns the original value
 */
function throwIfNil(value, error) {
    if (isNotNil(value)) {
        return value;
    }
    throw error ?? new Error(`Unexpected nil value ${value}`);
}
const isFalse = (bool) => bool === false;
exports.isFalse = isFalse;
const isTrue = (bool) => bool === true;
exports.isTrue = isTrue;
/**
 * gets around class erasure between packages
 * @param types
 */
const isInstanceOf = (...types) => (instance) => !!types.find(classType => instance instanceof classType ||
    (typeof instance === 'object' && instance?.constructor?.name === classType.name));
exports.isInstanceOf = isInstanceOf;
